angular.module('unica_survey.survey_controllers')

.controller('SurveyListController', function(
	$rootScope, $scope, $state,
	$confirm, $stateParams,
	SurveyListService, SurveyDeleteService
) {
	$scope.surveyList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadSurveys = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		SurveyListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.surveyList = $scope.surveyList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadSurveys();

	$scope.deleteSurvey = function(surveyId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il survey?',
			text: 'Confermi la cancellazione del survey?'
		}).then(function() {

			$scope.showLoader();
			SurveyDeleteService
				.delete( surveyId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.surveyList, function(survey, key) {
							if ( survey.id == surveyId ) {
								$scope.surveyList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Survey eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

})

;